import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { useWindowSize } from "../../../hooks/useWindowSize";

export interface CashierReportHeaderProps {
    onExportExcel: () => void;
    onExportCSV: () => void;
}

export default function CashierReportHeader({ onExportExcel, onExportCSV }: CashierReportHeaderProps){
    const { t } = useTranslation();
    const { innerWidth } = useWindowSize();
    const mobile = useMemo(() => innerWidth < 600, [innerWidth]);
    
    return (
        <div className="ms-2">
            <MDBBtn color="link" onClick={onExportExcel} hidden={mobile}>
                <MDBIcon icon="file-excel" color="success" className="me-1"/>
                <span>{t('export_to_excel')}</span>
            </MDBBtn>
            <MDBBtn color="link" onClick={onExportCSV} hidden={mobile}>
                <MDBIcon icon="file-csv" color="success" className="me-1"/>
                <span>{t('export_to_csv')}</span>
            </MDBBtn>

            <MDBBtn tag="a" color="none" onClick={onExportExcel} className="p-2" hidden={!mobile}>
                <MDBIcon icon="file-excel" size="lg" color="success" className="me-1"/>
            </MDBBtn>
            <MDBBtn tag="a" color="none" onClick={onExportCSV} className="p-2" hidden={!mobile}>
                <MDBIcon icon="file-csv" size="lg" color="success" className="me-1"/>
            </MDBBtn>
        </div>
    )
}